module.exports = __webpack_public_path__ + "static/img/kids-thankyou@2x.5e5d105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kids-thankyou@2x.png
// module id = 344
// module chunks = 0